import { useState } from "react";
import "./FAQ.css";
import {faqData} from "./faqData";
import closeBtn from '../../../images/FAQ/lyra-icon-fi_plus-circle.png'
import openBtn from '../../../images/FAQ/lyra-icon-fi_minus-circle.png'

export default function FAQ() {
    const [activeTab, setActiveTab] = useState("Оренда");
    const [openIndex, setOpenIndex] = useState(null);

    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <div id='section4' className="faq-container section4">
            <h2 className="faq-title">
                Запитання та відповіді (<span className="faq-highlight">FAQ</span>)
            </h2>
            <div className="faq-tabs">
                {Object.keys(faqData).map((tab) => (
                    <span
                        key={tab}
                        className={activeTab === tab ? "active-tab" : ""}
                        onClick={() => {
                            setActiveTab(tab)
                            toggleFAQ(null)
                        }}
                    >
                        {tab}
                     </span>
                ))}
            </div>
            <div className="faq-list">
                {faqData[activeTab].map((item, index) => (
                    <div key={index} className="faq-item">
                        <button className="faq-question" onClick={() => toggleFAQ(index)}>
                            <p className='faq-question-span'> {item.question}</p>
                            <span className="faq-icon">{openIndex === index ? <img className='faq-close-btn' src={openBtn} alt="Показати"/> :
                                <img className='faq-btn' src={closeBtn} alt="Закрити"/>}</span>
                        </button>
                        <div
                            className={`faq-answer ${openIndex === index ? "open" : ""}`}
                            dangerouslySetInnerHTML={{ __html: item.answer }}
                        ></div>
                    </div>
                ))}
            </div>
        </div>
    );
}